import ListEventContainer from "./MainContainer";

function ListEventPage(){
    return(
        <ListEventContainer />
    )
}

export default ListEventPage